export default __webpack_public_path__ + "static/media/md-card-bg-AzureDevOps.29611ed7.png";